/* -------------------------------------------------------------------------- */
/* START::SubComponents                                                       */
/* -------------------------------------------------------------------------- */

import React, { useState } from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { RhButton, RhButtonMode } from '../../../core/RhButton';
import { RhCard } from '../../../core/RhCard';
import { H2 } from '../../../core/Styles';
import { StudySectionModuleCardsDiv } from './StudySectionModuleCards';

export const StudySectionDayCard = (props: { title: string; children: React.ReactNode }) => {
  const [isChildrenShown, setIsChildrenShown] = useState(true);
  return (
    <StudySectionModuleCardsDiv>
      <RhCard mode="tiled">
        <div className="flex items-center justify-between">
          <H2>{props.title}</H2>
          <RhButton
            key="module-collapse"
            mode={RhButtonMode.subtle}
            prefixIcon={isChildrenShown ? FiChevronUp : FiChevronDown}
            iconSize={18}
            background="#fff"
            onClick={() => setIsChildrenShown(is => !is)}
          />
        </div>
        {isChildrenShown && props.children}
      </RhCard>
    </StudySectionModuleCardsDiv>
  );
};
